import MainImg from "./MainImg";
import CivilBlock from "./CivilBlock";
import CivilText from "./CivilText";

export default function Structural() {
  return (
    <>
    <MainImg />
    <CivilText />
    <CivilBlock />
    </>
  );
}